import { createFileRoute } from "@tanstack/react-router";
import { nearbyDogSuggestionsApiRoute } from "@/features/discovery";

export const Route = createFileRoute("/api/search-suggestions/dogs")({
    ...nearbyDogSuggestionsApiRoute,
});
